import { Box, Spinner } from '@grupoboticario/flora-react';

import { styles } from './Loader.styles';

const Loader = () => {
  return (
    <Box css={styles.loader}>
      <Spinner size='xl' thickness='4px' speed='400ms' color='$nonInteractiveAltAuxiliar' />
    </Box>
  );
};

export default Loader;
